<div class="wrapper">
  <div *ngIf="customCheckboxRef" class="heading-container">
    <ng-container *ngTemplateOutlet="customCheckboxRef"></ng-container>
  </div>
  <super-table-checkbox
    class="heading-container"
    *ngIf="checkbox && !customCheckboxRef"
  ></super-table-checkbox>
  <ng-container
    *ngIf="
      !checkbox &&
      !customCheckboxRef && {
        direction: direction | async
      } as vm
    "
  >
    <button
      type="button"
      *ngIf="sort != null; else sorterless"
      class="heading-container"
      [class.active]="vm.direction"
      (click)="
        doSort(
          vm.direction === 'asc'
            ? 'desc'
            : vm.direction === 'desc'
              ? null
              : 'asc'
        )
      "
    >
      <ng-container *ngTemplateOutlet="content"></ng-container>
      <span class="icon-container">
        <riv-icon
          [name]="vm.direction !== 'desc' ? 'ArrowUp' : 'ArrowDown'"
          [size]="12"
        ></riv-icon>
      </span>
    </button>
    <ng-template #sorterless>
      <div truncate class="heading-container">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>
    </ng-template>
    <ng-template #content>
      <ng-content> </ng-content>
      <riv-help *ngIf="help" [help]="help" [size]="12"></riv-help>
    </ng-template>
  </ng-container>
</div>
<div
  *ngIf="canResize"
  class="bar"
  (superTableHeader)="_.onResize($event)"
  [ngStyle]="fixedWidth && { display: 'none' }"
></div>
